/**
 * product-visualizer-config.js
 * Configuracoes editaveis do Product Visualizer — Limone Galleria.
 *
 * Este arquivo NAO contem logica. Apenas dados de configuracao.
 * Edite aqui para adaptar nomes de variantes, overlays e debug.
 */

window.ProductVisualizerConfig = {

  // ---------------------------------------------------------------------------
  // DEBUG
  // true  = exibe logs detalhados no console do browser
  // false = silencioso (producao)
  // ---------------------------------------------------------------------------
  debug: true,

  // ---------------------------------------------------------------------------
  // DETECCAO DE ORIENTACAO
  // Os valores abaixo devem corresponder EXATAMENTE aos nomes usados
  // nos arquivos de overlay (parte {orientation} do nome do arquivo).
  // ---------------------------------------------------------------------------
  orientation: {
    squareThreshold: 0.1,
    values: {
      vertical:   'vertical',
      horizontal: 'horizontal',
      square:     'quadrado',   // arquivos usam 'quadrado', nao 'square'
    },
  },

  // ---------------------------------------------------------------------------
  // MATERIAIS
  // Mapeamento: valor da opcao na variante Shopify -> chave interna
  // A chave interna deve corresponder ao {material} no nome do arquivo PNG.
  // ---------------------------------------------------------------------------
  materials: {
    paper: [
      'papel fotografico 200g',
      'papel fotográfico 200g',
      'papel fotografico',
      'papel fotográfico',
      'papel',
      'photo paper',
      'paper',
    ],
    canvas: [
      'canvas fosco 370g 100% algodao',
      'canvas fosco 370g 100% algodão',
      'canvas fosco 370g',
      'canvas fosco',
      'canvas',
    ],
  },

  // ---------------------------------------------------------------------------
  // MOLDURAS
  // Mapeamento: valor da opcao na variante Shopify -> chave interna
  // A chave interna deve corresponder ao {frame} no nome do arquivo PNG.
  // 'none' = sem moldura = sem overlay (nao tenta carregar arquivo)
  // ---------------------------------------------------------------------------
  frames: {
    none:    ['sem moldura', 'no frame', 'none'],
    natural: ['natural'],
    freijo:  ['freijó', 'freijo'],
    imbuia:  ['imbuia'],
    preto:   ['preta', 'preto', 'black'],  // arquivo: ...-preto.png
    branco:  ['branca', 'branco', 'white'], // arquivo: ...-branco.png
  },

  // ---------------------------------------------------------------------------
  // POSICAO DAS OPCOES NA VARIANTE SHOPIFY
  // variant.options e um array base-0.
  // Exemplo: "A3 / Canvas Fosco 370g / Freijó"
  //   options[0] = Tamanho  (ignorado pelo visualizador)
  //   options[1] = Material
  //   options[2] = Moldura
  // ---------------------------------------------------------------------------
  optionIndex: {
    material: 1,
    frame:    2,
  },

  // ---------------------------------------------------------------------------
  // OVERLAYS
  // pattern: template do nome do arquivo PNG em assets/
  // Variaveis: {material}, {orientation}, {frame}
  //
  // Convencao dos arquivos existentes:
  //   overlay-{material}-{orientation}-{frame}-v2.png
  //   material:    paper | canvas
  //   orientation: vertical | horizontal | quadrado
  //   frame:       natural | freijo | imbuia | preto | branco
  // ---------------------------------------------------------------------------
  overlay: {
    pattern: 'overlay-{material}-{orientation}-{frame}-v2.png',
  },

  // ---------------------------------------------------------------------------
  // SELETORES DO TEMA PARA LOCALIZAR O VARIANT-PICKER
  // ---------------------------------------------------------------------------
  variantPickerSelectors: [
    'variant-picker[data-template-product-match="true"]',
    'variant-picker',
  ],

};